<template>
    <div class="history-order">
        <div class="container">
            <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
              Повернутися
            </a>
            <div :class="['history-order__wrapp',{'disabled':documentDisabled}]">
                <div class="history-order__item">
                    <div class="history-order__head">
                        Страховий продукт
                    </div>
                    <div class="history-order__form-group">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Компанія</label>
                                <input type="text" v-if="skeletonOff" class="form-control" v-model="order.companyInfo.name" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Об'єкт страхування</label>
                                <input type="text" v-if="skeletonOff" class="form-control" v-model="order.insuranceObject.homeType.name" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Страхова сума</label>
                                <input type="text" v-if="skeletonOff" class="form-control" v-model="order.insuranceObject.insuranceAmount.name" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="history-order__item">
                    <div class="history-order__head">
                        Розрахунок
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Дата дії договору:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Початок</label>
                                <input v-if="skeletonOff" disabled v-model="order.contract.startedAt" class="form-control date-selector">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Закінчення</label>
                                <input v-if="skeletonOff"  disabled v-model="order.contract.finishedAt" class="form-control date-selector">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Розрахунковий період</label>
                                <input v-if="skeletonOff" type="text" class="form-control" v-model="order.insuranceObject.insurancePeriod.name" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__item history-order__client">
                    <div class="history-order__head">
                        Дані страхувальника
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Ідентифікація:</div>
                        <div class="row">
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>Повне ім'я</label>
                                <input v-if="skeletonOff" type="text" placeholder="" class="form-control" v-model="order.insurant.fullName" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>Дата народження</label>
                                <input v-if="skeletonOff" v-model="order.insurant.dateBirthAt" class="form-control date-selector" placeholder="" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label v-if="order.insurant.documentation.documentType == 3">Запис</label>
                                <label v-else>Серія паспорту</label>
                                <input v-if="skeletonOff" type="text" placeholder="Запис" class="form-control" v-model="order.insurant.documentation.serial" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="!this.isDocumentERetiree(order.insurant.privilegeTypeId)" class="col-md-4">
                                <label v-if="order.insurant.documentation.documentType == 3">Номер</label>
                                <label v-else>Номер паспорту</label>
                                <input v-if="skeletonOff" type="text" placeholder="Документ №" class="form-control" v-model="order.insurant.documentation.number" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>{{ !this.isDocumentERetiree(order.insurant.privilegeTypeId) ? 'Дата выдачі' : 'Закінчення дії' }}</label>
                                <input v-if="skeletonOff" v-model="order.insurant.documentation.dateOfIssue" class="form-control date-selector" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>{{isLegalType() ? 'ЄДРПОУ' : 'ІПН' }}</label>
                                <input v-if="skeletonOff" type="text" class="form-control" v-model="order.insurant.documentation.uin" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Контактна інформація:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Телефон</label>
                                <input v-if="skeletonOff" type="text" placeholder="Телефон" class="form-control" v-model="order.insurant.phone" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Email</label>
                                <input v-if="skeletonOff" type="text" placeholder="Email" class="form-control" v-model="order.insurant.email" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Адреса</label>
                                <input v-if="skeletonOff" type="text" placeholder="Адреса" class="form-control" v-model="order.insurant.address" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__item">
                    <div class="history-order__head">Застрахований об'єкт</div>
                    <div class="history-order__form-group">
                        <div class="history-order">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Місто</label>
                                    <input v-if="skeletonOff" type="text" placeholder="Місто" class="form-control" v-model="order.insuranceObject.homeCity.name_full_name_ua" disabled>
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                                <div class="col-md-6">
                                    <label>Вулиця</label>
                                    <input v-if="skeletonOff" type="text" placeholder="Вулиця" class="form-control" v-model="order.insuranceObject.homeStreet" disabled>
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Номер будинку</label>
                                    <input v-if="skeletonOff" type="text" placeholder="Номер будинку" class="form-control" v-model="order.insuranceObject.homeHouse" disabled>
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                                <div class="col-md-6">
                                    <label>Квартира</label>
                                    <input v-if="skeletonOff" placeholder="Квартира" v-model="order.insuranceObject.homeApartment" class="form-control" disabled>
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="history-order__price">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="history-order__price__item">
                                <p>Платіж:</p>
                                <b> {{ showPrice() }} <span>грн</span></b>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="this.loadData" class="partner-order__nav">
                    <div class="row">
                        <div class="col-md-8" v-if="order.edit">
                            <div class="row">
                                <div v-if="order.statusId == 1" class="col-md-6">
                                    <button type="button" @click="declare(order)" class="btn-blue-w">Редагувати і заявити</button>
                                </div>
                                <div v-if="order.statusId == 5" class="col-md-6">
                                    <button :disabled="isСoncludeProcess" type="button" @click="declare(order, false, false, 2)" class="btn-blue-w">
                                        <span v-if="isСoncludeProcess" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span v-else>Продовжити</span>
                                    </button>
                                </div>
                                <div class="col-md-6">
                                    <button type="button" @click="draft()" class="btn btn-dark">Переглянути чернетку</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="!hideCopyForApi">
                            <button :disabled="isCopyProcess" type="button" @click="copy(order)" class="btn btn-success">
                                <span v-if="isCopyProcess" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span v-else>Копіювати</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import { showOrder } from '@/api/order';
import { customerMixin, HistoryMixin } from "../../mixin";

export default {
    components: {Multiselect},
    mixins: [customerMixin, HistoryMixin],
    data: function () {
        return {
            loadMoreOptions: {},
            loadData: false,
            isCopyProcess: false,
            isСoncludeProcess: false,
            togglerVisible: true,
            documentDisabled: true,
            skeletonOff: false,
            orderId: null,

            order: {
                offer: {},
                contract: {},
                companyInfo: {},
                insuranceObject: {},
                insurant:{
                    documentation: {},
                }
            }
        };
    },

     async created() {
        this.order = await showOrder(this.$route.params.orderId).then((response) => {
            return response.data.data;
        });

        this.loadData = true;
        this.skeletonOff = true;

        this.getContractPeriod();
     },

    mounted () {
        this.getContractPeriod();
    },

    methods: {
        draft() {
            window.open(`/api/orders/draft/${this.$store.getters.USER.id}/${this.$route.params.orderId}`);
        },

        showPrice() {
            let price = parseFloat(this.order.price) + parseFloat((this.order?.dgo?.price || 0));

            if (isNaN(price)) {
                return 0;
            }

            return price.toFixed(2);
        },

        showDiscountPrice() {
            if (this.order.discountPrice) {
                let price = parseFloat(this.order.discountPrice);

                if (isNaN(price)) {
                    return 0;
                }

                return price.toFixed(2);
            }

            return 0;
        },

        // isLegalType() {
        //     //вынести это в миксин
        //   return this.order.insurant.customerTypeId === 2;
        // },

        getContractPeriod(){
            if(this.order.offer.yearProgram){
                this.orderPeriod = '1 рік';
            }else{
                if(this.order.offer.period_option == 1){
                    this.orderPeriod = this.order.offer.period_option+' день'
                }else if(this.order.offer.period_option > 1 && this.order.offer.period_option < 5){
                    this.orderPeriod = this.order.offer.period_option+' дні'
                }else {
                    this.orderPeriod = this.order.offer.period_option+' днів'
                }
            }
        },
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

